import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Reducers } from '../../store/types';
import { POLICIES } from '../../Config';
import { UserProfile } from '../../api/account/models/UserProfile';
import hasPolicies from 'common/utils/hasPolicies';

interface Props {
    policies: Array<keyof typeof POLICIES>
    type?: 'OR' | 'AND';
    roles?: string[];
    children: JSX.Element;
};

const PolicyRoute: React.FC<Props> = ({ children, policies, type = 'OR', roles }: Props) => {
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const allowedByPolicy = hasPolicies(userProfile, policies, type);
    const allowedByRole = roles && userProfile?.roles
        ? roles.some(r => userProfile.roles.includes(r))
        : false;

    if (!allowedByPolicy && !allowedByRole) {
        return <Navigate replace={true} to={'/403'} state={{ from: '/' }} />;
    }

    return children;
};

export default PolicyRoute;
